import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";

type Props = {
  style?: StyleProp<ViewStyle>;
};

export default function Visa({ style }: Props) {
  return (
    <Svg width={38} height={24} fill="none" style={style}>
      <Path d="M37.782 0H0v24h37.782V0z" fill="#fff" />
      <Path d="M37.151 20.1H.63v3.274h36.523v-3.275z" fill="#F7B600" />
      <Path
        d="M37.151.63H.63v3.274h36.523V.63zM15.249 7.51l-3.773 9.002H9.015L7.157 9.328c-.111-.44-.21-.603-.552-.79a9.704 9.704 0 00-2.297-.765l.054-.262h3.964a1.086 1.086 0 011.074.918l.98 5.214 2.422-6.122 2.447-.01zm9.643 6.063c.01-2.375-3.283-2.506-3.262-3.568 0-.322.315-.666.988-.754a4.403 4.403 0 012.297.403l.407-1.909a6.277 6.277 0 00-2.177-.399c-2.302 0-3.922 1.225-3.936 2.974-.014 1.296 1.158 2.018 2.038 2.449.908.44 1.212.724 1.209 1.117 0 .604-.725.875-1.4.875a4.875 4.875 0 01-2.39-.568l-.424 1.973c.546.248 1.55.465 2.588.477 2.45 0 4.048-1.209 4.055-3.08l.007.01zm6.071 2.928h2.154l-1.874-8.99h-1.987a1.06 1.06 0 00-.992.661l-3.498 8.34h2.449l.484-1.345h2.988l.276 1.335zm-2.592-3.178l1.225-3.38.7 3.38H28.37zm-9.795-5.812l-1.924 9h-2.33l1.924-9h2.33z"
        fill="#1A1F71"
      />
    </Svg>
  );
}
